import { useEffect } from "react";

import Login from "./Login";
import { useRootStore } from "store";

export default function AuthenticateInternalUser() {
  const { fetchInternalUserLogin } = useRootStore((state) => state.user);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    fetchInternalUserLogin(code);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Login />;
}
